<template>
  <div
    ref="form"
    class="hkl-form"
    :class="{'edit': canEdit, 'read-only': !canEdit}"
  >
    <slot />
  </div>
</template>
<script>
import { computed, provide } from 'vue-demi'
import { PROVIDE_KEYS } from './consts'
import { useRefForm } from './hook'

export default {
  name: 'HKLForm',
  props: {
    canEdit: {
      type: Boolean,
      default: () => true,
    },
  },
  setup (props) {
    const formRef = useRefForm()
    const canEdit = computed(() => props.canEdit)
    provide(PROVIDE_KEYS.CAN_EDIT, canEdit)
    return {
      ...formRef,
    }
  },
}
</script>
